import React, { forwardRef } from 'react';
import { body } from './fullscreenOverlay.styles';
import type { FullscreenOverlayBodyProps } from './types';

/**
 * FullscreenOverlayBody Component
 *
 * Main content area that scrolls independently.
 * Supports different padding options and variant-specific styling.
 *
 * @example Standard body with padding
 * <FullscreenOverlay.Body padding="standard">
 *   <p>Content with standard padding</p>
 * </FullscreenOverlay.Body>
 *
 * @example Edge-to-edge content (for images, maps, etc.)
 * <FullscreenOverlay.Body padding="edge-to-edge">
 *   <img src="..." alt="..." />
 * </FullscreenOverlay.Body>
 */
export const FullscreenOverlayBody = forwardRef<HTMLElement, FullscreenOverlayBodyProps>(
  ({ children, padding = 'standard', variant = 'standard' }, ref) => {
    return (
      <main ref={ref} className={body({ padding, variant })}>
        {children}
      </main>
    );
  },
);

FullscreenOverlayBody.displayName = 'FullscreenOverlayBody';
